// tslint:disable:no-any
import logger from "../util/logger";
declare var window: any;
declare var module: any;
declare var process: any;

import { createStore, applyMiddleware, compose, Store } from "redux";

import { rootReducer, ReduxState } from "./reducers";
import thunk from "redux-thunk";

// import { routerReducer, routerMiddleware } from 'react-router-redux';
// import { history } from './history';

function getComposer() {
    let composer = compose;

    if (process.env.NODE_ENV !== "production") {
        const composeEnhancers =
            // NOTE(vipentti): Requires installing of Redux dev tools extension
            // https://github.com/zalmoxisus/redux-devtools-extension
            window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
                ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
                      // Specify extension’s options like here name,
                      // actionsBlacklist, actionsCreators or immutablejs support
                  })
                : compose;

        composer = composeEnhancers;
    }

    return composer;
}

export default function createRootStore(): Store<ReduxState> {
    // const historyMiddleware = routerMiddleware(history);

    const composer = getComposer();

    const store = createStore<ReduxState>(
        rootReducer,
        composer(
            applyMiddleware(thunk)
            // applyMiddleware(historyMiddleware),
        ) as any
    );

    if (module && module.hot) {
        logger.log("Hot reloading store");

        module.hot.accept("./reducers", () => {
            logger.log("./reducers");
            store.replaceReducer(rootReducer);
        });
    }

    return store;
}



// WEBPACK FOOTER //
// ./src/ducks/RootStore.ts